import { render, staticRenderFns } from "./formCreateTrailer.vue?vue&type=template&id=4d45d9d5"
import script from "./formCreateTrailer.vue?vue&type=script&lang=js"
export * from "./formCreateTrailer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d45d9d5')) {
      api.createRecord('4d45d9d5', component.options)
    } else {
      api.reload('4d45d9d5', component.options)
    }
    module.hot.accept("./formCreateTrailer.vue?vue&type=template&id=4d45d9d5", function () {
      api.rerender('4d45d9d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/trailer/components/form/formCreateTrailer.vue"
export default component.exports